const getPatientPhone2 = ({ patient, value }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  const primaryPhone = patient['Contact Information']
    ? patient['Contact Information']['Primary Phone']
    : null;
  if (primaryPhone) {
    return primaryPhone.replace('+1 ', '').replace(/[\s()-]/g, '').slice(3, 6);
  }
  return null;
};

export default getPatientPhone2;



// WEBPACK FOOTER //
// ./src/utils/print/getPatientPhone2.js